export function displayNumToNum(displayNum) {
  const parsed = parseFloat(
    displayNum.replace(/,/g, "").replace(/[^0-9.,]/g, "")
  );
  return parsed;
}
